import { Trans } from '@lingui/react/macro';
import { UnitRequirementKind } from '@duke-hq/svc-api-db';
import type {
  RequirementKind,
  RequirementRef,
} from '@duke-hq/unit-generation-pipeline/schemas/sectionPlan';

const KIND_PREFIXES = {
  PERFORMANCE_CRITERION: 'PC',
  KNOWLEDGE_EVIDENCE: 'KE',
  PERFORMANCE_EVIDENCE: 'PE',
  FOUNDATION_SKILL: null,
} as const satisfies Record<UnitRequirementKind, RequirementKind | null>;

export const KIND_COLOURS = {
  PC: 'blue',
  KE: 'purple',
  PE: 'green',
} as const satisfies Record<RequirementKind, string>;

export const UNIT_REQUIREMENT_KIND_COLOURS = {
  PERFORMANCE_CRITERION: KIND_COLOURS.PC,
  KNOWLEDGE_EVIDENCE: KIND_COLOURS.KE,
  PERFORMANCE_EVIDENCE: KIND_COLOURS.PE,
  FOUNDATION_SKILL: 'orange',
} as const satisfies Record<UnitRequirementKind, string>;

export function requirementId({ kind, code }: RequirementRef): string {
  return `${kind}:${code}`;
}

export function requirementLabel({ kind, code }: RequirementRef): string {
  return code.startsWith(kind) ? code : `${kind} ${code}`;
}

export function unitRequirementLabel({
  kind,
  code,
}: {
  kind: UnitRequirementKind;
  code: string;
}): string {
  const prefix = KIND_PREFIXES[kind];
  return prefix == null ? code : requirementLabel({ kind: prefix, code });
}

export function UnitRequirementKindHeading({ kind }: { kind: UnitRequirementKind }) {
  switch (kind) {
    case UnitRequirementKind.PERFORMANCE_CRITERION:
      return <Trans>Performance criteria</Trans>;
    case UnitRequirementKind.KNOWLEDGE_EVIDENCE:
      return <Trans>Knowledge evidence</Trans>;
    case UnitRequirementKind.PERFORMANCE_EVIDENCE:
      return <Trans>Performance evidence</Trans>;
    case UnitRequirementKind.FOUNDATION_SKILL:
      return <Trans>Foundation skills</Trans>;
  }
}
